export const LIB_VERSION = '17.1.0'; // autogenerated
//# sourceMappingURL=version.js.map